import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import i18n from '../../locales/i18n';
import { FaArrowLeft } from 'react-icons/fa6';
import classes from "./LowBalancePage2.module.css";
import { setLanguage } from '../../store/slices/languageSlice';

const LowBalancePage2 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    const { t } = useTranslation();

    useEffect(() => {
        if (selectedLanguage && i18n.language !== selectedLanguage) {
            i18n.changeLanguage(String(selectedLanguage));
        }
    }, [selectedLanguage, i18n]);

    return (
        <div className={classes.page}>

            <select
                id="lang"
                name="lang"
                className={classes.dropdown}
                value={selectedLanguage}
                onChange={(event) => {
                    dispatch(setLanguage(event.target.value));
                }}
            >
                <option value="0">English</option>
                <option value="1">French</option>
            </select>

            {/* ══ LEFT — Brand Hero ══ */}
            <div className={classes.leftPanel}>
                <div className={classes.arcCircle} />

                <div className={classes.container}>

                    <button className={classes.back_button}
                        onClick={() => navigate(-1)}
                    >
                        <FaArrowLeft color='#fff' />
                    </button>

                    <div className={classes.info}>
                        <img
                            src="/assets/images/info.png"
                            alt="info"
                            className={classes.img}
                        />
                    </div>

                    <p className={classes.text}>
                        {t("246")}
                    </p>

                </div>

            </div>

            <div className={classes.copyrightFooter}>
                <div className={classes.copyrightDivider} />
                <div className={classes.copyrightInner}>
                    <span className={classes.copyrightBadge}>
                        <span className={classes.copyrightBadgeIcon}>⚽</span>
                        Football Masters
                    </span>
                    <p className={classes.copyrightText}>
                        © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
                    </p>
                    <p className={classes.copyrightSub}>All rights reserved</p>
                </div>
            </div>

        </div>
    )
}

export default LowBalancePage2